const routes = {
  groups: () => '/system-configuration/groups',
  groupsItem: (id) => `/system-configuration/groups/${id}`,
  tenantGroups: () => '/configuration/groups'
};

export default routes;
